export default "__VITE_ASSET__CW_ue7FI__"